import { Component, OnInit, Input } from '@angular/core';

import { NotyService } from '../../../services/common/noty.service';
import { TodoService } from '../../../services/events/todo.service';

@Component({
  selector: 'app-todos',
  templateUrl: './todos.component.html',
  styleUrls: ['./todos.component.css'],
})
export class TodosComponent implements OnInit {
  /**
   * Used to limit the component for a particular matter
   */
  @Input() matter_id: number;

  /**
   * List of todos found
   * @type {any}
   */
  todos: any = [];

  /**
   * Indicates if the todos are being fetched
   * @type {boolean}
   */
  loading: boolean = true;

  /**
   * Inactive todos filter
   * @type {boolean}
   */
  showInactive: boolean = false;

  /**
   * Indicates if the new todo form is opened
   * @type {boolean}
   */
  showNewTodoForm: boolean = false;

  /**
   * Sort options for sortablejs to sort the todos
   * @type {any}
   */
  sortOptions: any = {
    ghostClass: 'ghost-class',
    chosenClass: 'chosen-class',
    dragClass: 'drag-class',
    handle: '.draggable-elem',
    onUpdate: (event: any) => {
      this.updatePosition();
    },
  };

  /**
   * Constructor
   * @param {AlertService} private alertService Shows notifications
   * @param {TodoService}  private todoService  Provides access to todos in the backend
   */
  constructor(private notyService: NotyService, private todoService: TodoService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loadTodos();
  }

  // Component methods

  /**
   * Add a day to the todo start
   * @param {any} todo Todo to add a day for
   */
  addADay(todo: any) {
    todo.addingADay = true;
    this.todoService
      .addADay(todo)
      .then((response_json) => {
        todo.addingADay = false;
        this.notyService.notify('Added a day to the todo', 'success', 5000, 'topLeft');
        this.loadTodos();
      })
      .catch(() => {
        todo.addingADay = false;
        this.notyService.notify('Error adding a day to the todo', 'error', 5000, 'topLeft');
      });
  }

  /**
   * Handles form result of todo form for both new and edit
   * @param {any} event Form result event
   */
  formResult(event: any) {
    if (event == 'cancelled') {
      this.showNewTodoForm = false;
    } else if (event == 'saved') {
      this.showNewTodoForm = false;
      this.loadTodos();
    }
  }

  /**
   * Load todos
   */
  loadTodos() {
    if (this.matter_id)
      this.todoService.getMatterTodos(this.matter_id, this.showInactive).then((response_json) => {
        this.todos = response_json;
        this.loading = false;
      });
    else
      this.todoService.getTodos().then((response_json) => {
        this.todos = response_json;
        this.loading = false;
      });
  }

  /**
   * Mark a todo completed
   * @param {any} todo Todo to mark completed
   */
  markCompleted(todo: any) {
    todo.markingCompleted = true;
    this.todoService
      .markCompleted(todo)
      .then((response_json) => {
        todo.markingCompleted = false;
        this.notyService.notify('Todo marked complete', 'success', 5000, 'topLeft');
        this.loadTodos();
      })
      .catch(() => {
        todo.markingCompleted = false;
        this.notyService.notify('Error marking todo complete', 'error', 5000, 'topLeft');
      });
  }

  /**
   * Update todos position on sorting
   */
  updatePosition() {
    let positions: Array<number> = [];
    for (let todo of this.todos) positions.push(todo.id);
    this.todoService.updatePosition(positions);
  }
}
